import { Helmet } from 'react-helmet-async';

import { useAccount } from '../auth';

export const BrowserTabTitle = ({
  title,
  children,
}: {
  title?: string;
  children: any;
}) => {
  const { currentAccount } = useAccount();

  return (
    <Helmet>
      <title>
        {title || children} - {currentAccount.title || currentAccount.name} -
        Aquifer
      </title>
    </Helmet>
  );
};
